import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = ({ navinf = false }) => {
    return (
        <footer className={navinf ? 'footer margin' : 'footer'}>
            <p>© {new Date().getFullYear()} Minymol S.A.S - Todos los derechos reservados: Minymol<b>®</b></p>
            <p>CR 46 45 88, Cali - Valle</p>
            <div className='links-foot'>
                <a
                    href='https://wa.me/573169277199'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    (+57) 316 9277199
                </a>
                <a
                    href='mailto:minymolonline@gmail.com'
                >
                    minymolonline@gmail.com
                </a>
                <Link to='/condiciones'>Condiciones de uso</Link>
                <Link to='/politica'>Política de privacidad</Link>
                <Link to='/cookies'>Política de cookies</Link>
            </div>
        </footer>
    );
}

export default Footer;